/**
 * Testimonial V2 Slider Component
 */
if (!customElements.get('testimonial-slider')) {
  customElements.define(
    'testimonial-slider',
    class TestimonialSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.slidesPerViewDesktop = parseFloat(this.dataset.slidesPerViewDesktop) || 3;
        this.slidesPerViewMobile = parseFloat(this.dataset.slidesPerViewMobile) || 1.2;
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5;

        this.initSlider();
      }

      initSlider() {
        const sliderContainer = this.querySelector('.swiper');
        const paginationEl = this.querySelector('.swiper-pagination');
        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');

        if (!sliderContainer) return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: false,
          loop: true,
          autoHeight: false,
          pagination: {
            el: paginationEl,
            clickable: true,
            type: 'bullets',
          },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: Math.min(this.slidesPerViewDesktop, 5)
            }
          }
        };

        if (this.autoplay) {
          this.sliderOptions.autoplay = {
            delay: this.autoplayDelay * 1000,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(sliderContainer, this.sliderOptions);
        this.sliderInstance.init();
      }
    }
  );
}
